<script>
const DefaultAddressInfo = {
  addressLine1: '',
  addressLine2: '',
  city: '',
  country: '',
  latitude: '',
  legalName: '',
  longitude: '',
  postalCode: '',
  taxNumber: ''
}
export default {
  name: 'ContactInfo',
  props: {
    info: {
      type: Object,
      default: () => DefaultAddressInfo
    },
    width: {
      default: '100%'
    }
  },
  computed: {
    currentInfo () {
      return Object.assign({}, DefaultAddressInfo, this.info)
    }
  }
}
</script>

<template>
  <v-card
    :width="width"
    class="pa-4"
    color="#eeeeee"
    elevation="0"
  >
    <div>
      <h3>地址信息</h3>
      <div class="address-details">
        <div class="d-flex align-center justify-center">
          <span>legalName:</span>
          <v-spacer />
          <span>{{ currentInfo.legalName }}</span>
        </div>
        <div class="d-flex align-center justify-center">
          <span>addressLine1:</span>
          <v-spacer />
          <span>{{ currentInfo.addressLine1 }}</span>
        </div>
        <div class="d-flex align-center justify-center">
          <span>addressLine2:</span>
          <v-spacer />
          <span>{{ currentInfo.addressLine2 }}</span>
        </div>
        <div class="d-flex align-center justify-center">
          <span>city:</span>
          <v-spacer />
          <span>{{ currentInfo.city }}</span>
        </div>
        <div class="d-flex align-center justify-center">
          <span>country:</span>
          <v-spacer />
          <span>{{ currentInfo.country }}</span>
        </div>
        <div class="d-flex align-center justify-center">
          <span>postalCode:</span>
          <v-spacer />
          <span>{{ currentInfo.postalCode }}</span>
        </div>
        <div class="d-flex align-center justify-center">
          <span>taxNumber:</span>
          <v-spacer />
          <span>{{ currentInfo.taxNumber }}</span>
        </div>
        <div class="d-flex align-center justify-center">
          <span>经纬度:</span>
          <v-spacer />
          <span>{{ currentInfo.latitude }}, {{ currentInfo.longitude }}</span>
        </div>
      </div>
    </div>
  </v-card>
</template>

<style scoped>
.address-card h3 {
  margin-top: 0;
  color: #333;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.address-details {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>
